import { loadScript } from '@/config/thirdParty/loadScript';
import { isVendorEnabled, thirdPartyKeys } from '@/config/thirdParty/thirdPartyGate';
export { isVendorEnabled, readFlag, readKey, thirdPartyKeys, thirdPartyMasterEnabled } from '@/config/thirdParty/thirdPartyGate';
export { loadScript } from '@/config/thirdParty/loadScript';
/**
 * Usercentrics -- the consent management platform.
 *
 * This one gates other things: with the CMP absent no consent is recorded, so
 * anything downstream that waits on a consent event will wait forever. That is
 * why it is a flag and not a deletion, and why the flag is ON by default on the
 * production origins.
 */
const loadUsercentrics = async () => {
    const vendor = 'usercentrics';
    if (!isVendorEnabled(vendor))
        return { vendor, loaded: false, reason: 'flag-off' };
    const settingsId = thirdPartyKeys.usercentricsSettingsId();
    if (!settingsId)
        return { vendor, loaded: false, reason: 'no-key' };
    try {
        await loadScript({
            id: 'usercentrics-cmp',
            src: 'https://web.cmp.usercentrics.eu/ui/loader.js',
            data: { 'settings-id': settingsId }
        });
        return { vendor, loaded: true, reason: 'loaded' };
    }
    catch {
        return { vendor, loaded: false, reason: 'failed' };
    }
};
/** Google AdSense. */
const loadAdsense = async () => {
    const vendor = 'adsense';
    if (!isVendorEnabled(vendor))
        return { vendor, loaded: false, reason: 'flag-off' };
    const client = thirdPartyKeys.adsenseClient();
    if (!client)
        return { vendor, loaded: false, reason: 'no-key' };
    try {
        await loadScript({
            id: 'google-adsense',
            src: `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`,
            async: true,
            crossOrigin: 'anonymous'
        });
        return { vendor, loaded: true, reason: 'loaded' };
    }
    catch {
        return { vendor, loaded: false, reason: 'failed' };
    }
};
/**
 * Bootstrap every head-injected third-party script.
 *
 * Called once from `main.ts`. Never throws: a vendor that is off, unkeyed or
 * unreachable must be indistinguishable from one that was never configured.
 *
 * Google Tag Manager is not here -- `vue-gtm` owns its own script tag and is
 * gated in `@/config/plugins/vueGtmOptions`. Smartlook is not here either --
 * it is an npm SDK, gated and dynamically imported in
 * `@/config/store/setupGlobalThis`.
 */
export const setupThirdPartyScripts = async () => {
    const outcomes = await Promise.all([
        loadUsercentrics(),
        loadAdsense()
    ]);
};
